import { useNavigate, useSearchParams } from 'react-router'
import { useCallback } from 'react'
import { buildUrlWithCSelections, getCSelections } from '../utils/navigation'

/**
 * Custom navigation hook that preserves c_selections parameter
 *
 * Usage:
 *   const navigate = useNavigateWithParams()
 *   navigate('/workflows')  // Will automatically add ?c_selections=...
 */
export function useNavigateWithParams() {
  const reactRouterNavigate = useNavigate()
  const [searchParams] = useSearchParams()

  return useCallback(
    (to: string | number, options?: { replace?: boolean; state?: any; params?: Record<string, string> }) => {
      // Handle numeric navigation (back/forward)
      if (typeof to === 'number') {
        reactRouterNavigate(to)
        return
      }

      // Get additional params from options or current URL
      const additionalParams = options?.params || {}

      // Preserve c_selections from current URL
      const cSelections = getCSelections()
      if (cSelections) {
        additionalParams.c_selections = cSelections
      }

      // Build full path with preserved params
      const fullPath = buildUrlWithCSelections(to, additionalParams)

      // Navigate with React Router
      reactRouterNavigate(fullPath, {
        replace: options?.replace,
        state: options?.state
      })
    },
    [reactRouterNavigate, searchParams]
  )
}
